import {checkValid} from "../../../globalModels/functions/ModelsValidate";
// let _ = require('lodash');

export function HSCodeItemGroup() {

  this.checkValid = checkValid

  this.data = {
    id: '',
    codeEU: '',
    codeUSA: '',
    material: '',
    dutyPercent: '0',
}

  this.validation = {
    codeEU: false,
    material: false,
    dutyPercent: false,
  }

  this.validationTranslate = {
    codeEU: '',
    codeUSA: '',
    material: '',
    dutyPercent: '',
  }

  this.validationTxt = {
    codeEU: false,
    codeUSA: false,
    material: false,
    dutyPercent: false,
  }

}


/*****************   SETTERS   ******************/



HSCodeItemGroup.prototype.setHSCodeItemGroup = function (val) {
  this.data.id = val.group_uid
  this.data.codeEU = val.hs_code_eu
  this.data.codeUSA = val.hs_code_usa
  this.data.material = val.materials.map(m => {
    return {
      proform_value: m
    }
  })
  this.data.dutyPercent = val.duty_percent
}


/*****************   GETTERS   ******************/


/*******************   FUNCTIONS   *************/



/******************  VALIDATIONS  *****************/


HSCodeItemGroup.prototype.firstValidation = function () {

  let data = this.data

  let validationItems = {
    codeEU: data.codeEU,
    codeUSA: data.codeUSA,
    material: data.material,
    dutyPercent: data.dutyPercent,
  }

  let validationOptions = {
    codeEU: {type: ['empty']},
    codeUSA: {type: ['empty']},
    material: {type: ['empty']},
    dutyPercent: {type: ['empty']},
  }

  return (this.checkValid(validationItems, validationOptions))
}

/******************  PREPARE DATA  *****************/


HSCodeItemGroup.prototype.prepareData = function() {

  let data = {
    'group_uid' : this.data.id,
    'hs_code_eu' : this.data.codeEU + '',
    'hs_code_usa' : this.data.codeUSA + '',
    'materials' : this.data.material.map(m => {
      return m.proform_value.id
    }),
    'duty_percent' : this.data.dutyPercent,
  }

  return data
}